
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class ECommerceConnectorService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.user_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_ECOMM_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getEComConnectorOrderStatusDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getEComConnectorOrderStatusDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getEComConnectorJobStatusDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getEComConnectorJobStatusDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static uploadFabricStylesToEcomConnectorJob(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "uploadFabricStylesToEcomConnectorJob",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static uploadWebSkuInventoriesToEcomConnectorJob(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "uploadWebSkuInventoriesToEcomConnectorJob",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static processFailedWebOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "processFailedWebOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.user_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });

       ServiceExecutorProxy.executeService(methodName, input,this.user_data_url,responseCallBack, errorCallBack);
    }
  }
}
